import { render, staticRenderFns } from "./RankBox.vue?vue&type=template&id=68095236&scoped=true&"
import script from "./RankBox.vue?vue&type=script&lang=js&"
export * from "./RankBox.vue?vue&type=script&lang=js&"
import style0 from "./RankBox.vue?vue&type=style&index=0&id=68095236&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68095236",
  null
  
)

export default component.exports